import { render, staticRenderFns } from "./buyPage.vue?vue&type=template&id=3f982861&scoped=true"
import script from "./buyPage.vue?vue&type=script&lang=js"
export * from "./buyPage.vue?vue&type=script&lang=js"
import style0 from "./buyPage.vue?vue&type=style&index=0&id=3f982861&prod&lang=css"
import style1 from "./buyPage.vue?vue&type=style&index=1&id=3f982861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f982861",
  null
  
)

export default component.exports